// extracted by mini-css-extract-plugin
export default {"Wrapper":"LegendBox_Wrapper__oBAvh"};